import React from 'react';
// import { Link } from 'react-router-dom';
import { Button, IconButton, InputAdornment, TextField } from '@mui/material';

import jwtService from 'app/auth/services/jwtService';
import { Icon } from 'app/main/components';

interface LoginTabProps {
	form: any;
	handleChange: (event: any) => void;
	onSuccessLogin: (availableApps: any[]) => void;
}

export default function LoginTab({ form, handleChange, onSuccessLogin }: LoginTabProps) {
	const [visible, setVisible] = React.useState(false);
	const [loading, setIsLoading] = React.useState(false);

	function isFormValid() {
		return form.email.length > 0 && form.password.length > 0;
	}

	function handleSubmit(event) {
		event.preventDefault();
		setIsLoading(true);

		if (import.meta.env.VITE_MULTIPLE_LOGIN === 'true') {
			jwtService
				.signInMultipleApps(form.email, form.password)
				.then(({ availableApps }) => {
					onSuccessLogin(availableApps);
					setIsLoading(false);
				})
				.catch(error => {
					console.error(error);
					setIsLoading(false);
				});
		} else {
			jwtService
				.signInWithEmailAndPassword(form.email, form.password, import.meta.env.VITE_UID)
				.then(data => {
					setIsLoading(false);
				})
				.catch(error => {
					console.error(error);
					setIsLoading(false);
				});
		}
	}

	return (
		<>
			<form
				className="mt-32 flex w-full flex-col justify-center"
				name="loginForm"
				noValidate
				onSubmit={handleSubmit}
			>
				<TextField
					className="mb-16"
					label="Email"
					autoFocus
					type="email"
					name="email"
					value={form.email}
					onChange={handleChange}
					variant="filled"
					required
					fullWidth
				/>
				<TextField
					className="mb-16"
					label="Password"
					type={visible ? 'text' : 'password'}
					name="password"
					value={form.password}
					onChange={handleChange}
					variant="filled"
					required
					fullWidth
					InputProps={{
						classes: { adornedEnd: 'pr-0' },
						endAdornment: (
							<InputAdornment className="m-0" position="end">
								<IconButton onClick={() => setVisible(state => !state)}>
									{!visible ? <Icon icon="eye" /> : <Icon icon="eye-off" />}
								</IconButton>
							</InputAdornment>
						)
					}}
				/>
				{/* <div className="flex items-center justify-between">
					<FormControl>
						<FormControlLabel
							control={<Checkbox name="remember" checked={form.remember} onChange={handleChange} />}
							label="Remember Me"
						/>
					</FormControl>
					<Link className="font-medium" to="/pages/auth/forgot-password-2">
						Forgot Password?
					</Link>
				</div> */}
				<Button
					className="mx-auto mt-16 w-full"
					variant="contained"
					color="primary"
					type="submit"
					loading={loading}
					disabled={!isFormValid()}
				>
					LOGIN
				</Button>
			</form>
			{/* <div className="my-24 flex items-center justify-center">
				<Divider className="w-32" />
				<span className="mx-8 font-bold">OR</span>
				<Divider className="w-32" />
			</div>
			<Button variant="outlined" color="primary" size="small" className="mb-8 w-192 normal-case">
				Log in with Google
			</Button>
			<Button variant="outlined" color="primary" size="small" className="w-192 normal-case">
				Log in with Facebook
			</Button> */}
		</>
	);
}
